// src/pages/Dashboard/components/CasePanel/CasePanel.js

import React from 'react';
import CaseTitle from './CaseTitle';
import AnalysisSection from './AnalysisSection/AnalysisSection';
import JurisprudenceSection from './JurisprudenceSection/JurisprudenceSection';
import ClientDataSection from './ClientDataSection/ClientDataSection';
import DocumentsSection from './DocumentsSection/DocumentsSection';
import './CasePanel.css';

/**
 * Painel esquerdo com informações do caso (30%)
 * @param {object} casoSelecionado - Caso atualmente selecionado
 * @param {Array} jurisprudencias - Jurisprudências relacionadas
 * @param {boolean} loadingJurisprudencias - Se está carregando jurisprudências
 * @param {function} onViewJurisprudenciaDetails - Callback para ver detalhes de jurisprudência
 * @param {function} onRemoveJurisprudencia - Callback para remover jurisprudência
 * @param {function} onGenerateDocument - Callback para gerar documento
 * @param {boolean} debugMode - Se modo debug está ativo
 */
const CasePanel = ({ 
  casoSelecionado,
  jurisprudencias,
  loadingJurisprudencias,
  onViewJurisprudenciaDetails,
  onRemoveJurisprudencia,
  onGenerateDocument,
  debugMode
}) => {
  if (!casoSelecionado) {
    return (
      <div className="dashboard-left">
        <div className="no-caso-selected">
          <p>Selecione um caso no menu ou crie um novo</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-left">
      <CaseTitle caso={casoSelecionado} />
      
      <AnalysisSection caso={casoSelecionado} />
      
      <JurisprudenceSection
        jurisprudencias={jurisprudencias}
        loading={loadingJurisprudencias}
        onViewDetails={onViewJurisprudenciaDetails}
        onRemove={onRemoveJurisprudencia}
      />
      
      <ClientDataSection 
        caso={casoSelecionado}
        debugMode={debugMode}
      />
      
      <DocumentsSection
        caso={casoSelecionado}
        onGenerateDocument={onGenerateDocument}
      />
    </div>
  );
};

export default CasePanel;